import RolesUtil from 'permissions/utils/roles';
const TickmarkPermissions = {
  canEditTickmark: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData, projectID),
};

export default TickmarkPermissions;
